import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxMaskModule } from 'ngx-mask';
import { SharedModule } from 'src/app/shared';
import { HeaderComponent } from './header.component';
import { UpdateEmailComponent } from './update-email/update-email.component';
import { UpdateMobileNumberComponent } from './update-mobile-number/update-mobile-number.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        HttpClientModule,
        TranslateModule.forRoot({
        loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
        }
      }),
      NgOtpInputModule,
      NgxMaskModule,
      MatTooltipModule
    ],
  providers: [HttpClient],
    declarations: [
        HeaderComponent,
        UpdatePasswordComponent,
        UpdateMobileNumberComponent,
        UpdateEmailComponent
    ],
    exports: [HeaderComponent]
})
export class HeaderModule {
  static forRoot(): ModuleWithProviders<HeaderModule> {
    return {
      ngModule: HeaderModule
    };
  }
}
